/* import __COLOCATED_TEMPLATE__ from './conversation-attributes-search.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const ConversationAttributesSearch = templateOnlyComponent<Signature>();
export default ConversationAttributesSearch;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::ConversationAttributesSearch': typeof ConversationAttributesSearch;
    'inbox2/conversation-details-sidebar/sidebar-sections/conversation-attributes-search': typeof ConversationAttributesSearch;
  }
}
